import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import HappyScroll from "vue-happy-scroll";
import ElementUI from "element-ui";
import echarts from "echarts";

//mockjs模拟后端接口和数据
require("./mock.js");


import "element-ui/lib/theme-chalk/index.css";
import "vue-happy-scroll/docs/happy-scroll.css";
import "./assets/fonts/iconfont.css";
import "./style/index.less"
import "@/assets/css/reset.css";
import "./axios";
import 'katex/dist/katex.min.css'; // 全局导入 KaTeX 样式（新增）
import DOMPurify from 'dompurify';
import $ from "jquery";
import VueCompositionAPI from '@vue/composition-api';

Vue.use(VueCompositionAPI)
Vue.use(DOMPurify)
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts; // 添加全局的属性
// Vue.prototype.$axios = axios;
Vue.use(HappyScroll);
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
